import { createAsyncThunk } from '@reduxjs/toolkit';
import Relay from 'v2/services/relay';

const relay = new Relay('relay', '', '');
export const fetchLoiTemplates = createAsyncThunk(
  'loi_template/fetchLoiTemplates',
  async ({ pid, tid, status }) => {
    const result = await relay.get('', {
      action: 'loi_template',
      method: 'fetchAll',
      pid,
      ...(tid ? { tid } : {}),
      ...(status ? { status } : {}),
    });

    if (result.status === 200) {
      return result.json();
    }

    return result.status;
  },
);

export const createLoiTemplate = createAsyncThunk(
  'loi_template/createLoiTemplate',
  async ({ tid, pid }) => {
    return relay
      .post({}, '', {
        action: 'loi_template',
        method: 'create',
        tid,
        pid,
      })
      .then((result) => (result.status === 200 ? result.json() : result.status))
      .catch((error) => error.status);
  },
);

export const deleteLoiTemplate = createAsyncThunk(
  'loi_template/deleteLoiTemplate',
  async ({ did, tid, pid }) => {
    return relay
      .post({}, '', {
        action: 'loi_template',
        method: 'remove',
        tid,
        did,
        pid,
      })
      .then((result) => (result.status === 200 ? result.json() : result.status))
      .catch((error) => error.status);
  },
);
